(function () {
  function normalizeCollectionIntro() {
    if (window.location.pathname.replace(/\/$/, '') !== '/collections/all') return;

    var main = document.getElementById('main-content') || document.querySelector('main');
    if (!main || !main.querySelector('.collection-group')) return;

    var intro = main.querySelector('.text-center.mb-16');
    if (!intro) return;

    var eyebrow = intro.querySelector('p.tracking-widest');
    if (eyebrow) eyebrow.textContent = 'ESNC PERFUMES';

    var heading = intro.querySelector('h1');
    if (heading) heading.textContent = 'Check Our Latest Collections';

    var description = intro.querySelector('.prose');
    if (description) description.style.display = 'none';

    var links = intro.querySelectorAll('a');
    links.forEach(function (link) {
      if (/Take the SORA Test/i.test(link.textContent || '')) {
        (link.parentElement || link).style.display = 'none';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeCollectionIntro);
  } else {
    normalizeCollectionIntro();
  }

  window.addEventListener('pageshow', normalizeCollectionIntro);
  document.addEventListener('shopify:section:load', normalizeCollectionIntro);
  setTimeout(normalizeCollectionIntro, 250);
  setTimeout(normalizeCollectionIntro, 1000);
})();
